/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: 1, // boolean: loading screen on first visit
  themeToggle: 1, // boolean: allow user to change theme in header
  showProfilePhoto: 1, // boolean: determines if profile or graphic is shown
};

//Home Page
const greeting = {
  profilePhoto: "assets/profilenosuit.png", // photo path also hardcoded in Greeting.js line 56
  title: "Hello World 👋!",
  footer: "Copyright © Diego Araujo ", // footer + currentYear + "."
  // logo_name: "Mateo-Wallace",
  full_name: "Diego Araujo",
  subTitle:
    "Software Engineer building event-driven cloud backends at scale, and founder of Minas Digital — privacy-first AI that never leaves your machine.",
  resumeLink:
    "https://drive.google.com/file/d/1bWOSvX9H_SPmixipKrrC8d6LS7LI7zrx/view?usp=sharing",
};

// Error 404, Not Found
const errorPageInfo = {
  titleHighlight: "404",
  title: "Not Found",
  subTitle:
    "Sorry about that. It seems like you've made it to a secret page",
  image: 0, //for graphic make 0, for image make myImage.png
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/DiegoAR98",
  linkedin: "https://www.linkedin.com/in/diego-araujo1998/",
  gmail: "diegoaraujolive@hotmail.com",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive front-end interfaces using React, Svelte, Angular, and Tailwind CSS",
        "⚡ Creating application backends with Node.js, Express, .NET, and Python (Flask)",
        "⚡ Managing databases with SQL Server, MongoDB, MySQL, Sequelize, and SQLAlchemy",
        "⚡ Designing and implementing RESTful APIs, GraphQL, and webhooks",
        "⚡ Developing with TypeScript and JavaScript (ES6+) across the full stack",
        "⚡ Writing services in Python, C#, and Go, with test coverage via Jest and pytest",
      ],
      softwareSkills: [
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: { color: "#3178C6" },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: { backgroundColor: "#FFFFFF", color: "#F7DF1E" },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: { color: "#3776AB" },
        },
        {
          skillName: "C#",
          fontAwesomeClassname: "devicon-csharp",
          style: { color: "#239120" },
        },
        {
          skillName: "Go",
          fontAwesomeClassname: "simple-icons:go",
          style: { color: "#00ADD8" },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: { color: "#00599C" },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: { color: "#E34F26" },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: { color: "#1572B6" },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: { color: "#61DAFB" },
        },
        {
          skillName: "Svelte",
          fontAwesomeClassname: "simple-icons:svelte",
          style: { color: "#FF3E00" },
        },
        {
          skillName: "Angular",
          fontAwesomeClassname: "simple-icons:angular",
          style: { color: "#DD0031" },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: { color: "#7952B3" },
        },
        {
          skillName: "Tailwind CSS",
          fontAwesomeClassname: "simple-icons:tailwindcss",
          style: { color: "#06B6D4" },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "vscode-icons:file-type-node",
          style: { color: "#339933" },
        },
        {
          skillName: "Express.js",
          fontAwesomeClassname: "simple-icons:express",
          style: { color: "#8892B0" },
        },
        {
          skillName: ".NET",
          fontAwesomeClassname: "skill-icons:dotnet",
          style: { color: "#512BD4" },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "logos:flask",
          style: { color: "#8892B0" },
        },
        {
          skillName: "SQL Server",
          fontAwesomeClassname: "simple-icons:microsoftsqlserver",
          style: { color: "#CC2927" },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: { color: "#47A248" },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: { color: "#4479A1" },
        },
        {
          skillName: "Sequelize",
          fontAwesomeClassname: "simple-icons:sequelize",
          style: { color: "#52B0E7" },
        },
        {
          skillName: "SQLAlchemy",
          fontAwesomeClassname: "devicon:sqlalchemy",
          style: { color: "#d34a36" },
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: { color: "#DE33A6" },
        },
        {
          skillName: "REST APIs",
          fontAwesomeClassname: "mdi:api",
          style: { color: "#FF6E00" },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: { color: "#E94E32" },
        },
        {
          skillName: "Jinja2",
          fontAwesomeClassname: "simple-icons:jinja",
          style: { color: "#B41717" },
        },
      ],
    },
    {
      title: "Cloud & DevOps",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Building serverless Azure Functions with Event Hubs for real-time data processing",
        "⚡ Managing CI/CD pipelines and workflows with Azure DevOps",
        "⚡ Working with AWS services including DynamoDB, S3, and EC2",
        "⚡ Implementing automated workflows and integrations with SendGrid and Zoho APIs",
      ],
      softwareSkills: [
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: { color: "#0078D4" },
        },
        {
          skillName: "Azure DevOps",
          fontAwesomeClassname: "simple-icons:azuredevops",
          style: { color: "#0078D7" },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "skill-icons:aws-dark",
          style: { color: "#FF9900" },
        },
        {
          skillName: "DynamoDB",
          fontAwesomeClassname: "simple-icons:amazondynamodb",
          style: { color: "#4053D6" },
        },
        {
          skillName: "S3",
          fontAwesomeClassname: "simple-icons:amazons3",
          style: { color: "#569A31" },
        },
        {
          skillName: "EC2",
          fontAwesomeClassname: "simple-icons:amazonec2",
          style: { color: "#FF9900" },
        },
        {
          skillName: "GitHub",
          fontAwesomeClassname: "simple-icons:github",
          style: { color: "#5b77ef" },
        },
        {
          skillName: "SendGrid",
          fontAwesomeClassname: "simple-icons:sendgrid",
          style: { color: "#1A82E2" },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: { color: "#FFCA28" },
        },
        {
          skillName: "Cloudflare",
          fontAwesomeClassname: "simple-icons:cloudflare",
          style: { color: "#F38020" },
        },
      ],
    },
    {
      title: "AI & Automation",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Building multi-agent systems with CrewAI and LangGraph",
        "⚡ Shipping RAG pipelines over vector databases with ChromaDB and local embeddings",
        "⚡ Running local LLMs with Ollama for fully private, zero-cost inference",
        "⚡ Integrating LLM APIs (Claude, OpenAI) into applications",
        "⚡ Implementing agentic workflows and prompt engineering strategies",
        "⚡ Working with Model Context Protocol (MCP) for AI tool integration",
      ],
      softwareSkills: [
        {
          skillName: "OpenAI",
          fontAwesomeClassname: "simple-icons:openai",
          style: { color: "#412991" },
        },
        {
          skillName: "Anthropic",
          fontAwesomeClassname: "simple-icons:anthropic",
          style: { color: "#D4A574" },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: { color: "#3776AB" },
        },
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: { color: "#1C3C3C" },
        },
        {
          skillName: "LangGraph",
          fontAwesomeClassname: "mdi:graph-outline",
          style: { color: "#1C3C3C" },
        },
        {
          skillName: "CrewAI",
          fontAwesomeClassname: "mdi:robot-outline",
          style: { color: "#FF6B35" },
        },
        {
          skillName: "Ollama",
          fontAwesomeClassname: "simple-icons:ollama",
          style: { color: "#8892B0" },
        },
        {
          skillName: "ChromaDB",
          fontAwesomeClassname: "simple-icons:chroma",
          style: { color: "#FFC107" },
        },
        {
          skillName: "RAG",
          fontAwesomeClassname: "mdi:database-search-outline",
          style: { color: "#16A085" },
        },
        {
          skillName: "Model Context Protocol",
          fontAwesomeClassname: "mdi:connection",
          style: { color: "#DA70D6" },
        },
        {
          skillName: "Pydantic",
          fontAwesomeClassname: "simple-icons:pydantic",
          style: { color: "#E92063" },
        },
      ],
    },
  ],
};


const majorEducation = {
  data: [
    {
      title: "University of Central Florida",
      subtitle: "Certificate in Full Stack Web Development",
      logo_path: "ucf-logo.png",
      alt_name: "ucf logo",
      duration: "Oct 2023 - Apr 2024",
      descriptions: [
        "⚡ A six month intensive bootcamp course of 240 contact hours.",
        "⚡ Learned to work on multiple group projects integrating Git workflow.",
        "⚡ Gained the skill to become a MERN stack developer, creating various deployed websites with databases.",
      ],
      website_link:
        "https://badgr.com/public/assertions/epuoKGOpS76WCHgkeESjNw",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Build Multimodal Generative AI Applications",
      subtitle: "IBM | 2026",
      logo_path: "cert-badge.svg",
      certificate_link: "",
      alt_name: "IBM Multimodal GenAI",
      color_code: "#EAF1FF",
    },
    {
      title: "Advanced RAG with Vector Databases and Retrievers",
      subtitle: "IBM | 2026",
      logo_path: "cert-badge.svg",
      certificate_link: "",
      alt_name: "IBM Advanced RAG",
      color_code: "#EAF1FF",
    },
    {
      title: "Vector Databases for RAG: An Introduction",
      subtitle: "IBM | 2026",
      logo_path: "cert-badge.svg",
      certificate_link: "",
      alt_name: "IBM Vector Databases",
      color_code: "#EAF1FF",
    },
    {
      title: "Build RAG Applications: Get Started",
      subtitle: "IBM | 2026",
      logo_path: "cert-badge.svg",
      certificate_link: "",
      alt_name: "IBM Build RAG",
      color_code: "#EAF1FF",
    },
    {
      title: "Develop Generative AI Applications: Get Started",
      subtitle: "IBM | 2026",
      logo_path: "cert-badge.svg",
      certificate_link: "",
      alt_name: "IBM Develop GenAI",
      color_code: "#EAF1FF",
    },
    {
      title: "Design, Develop, and Deploy Multi-Agent Systems with CrewAI",
      subtitle: "DeepLearning.AI | 2026",
      logo_path: "deeplearningai.png",
      certificate_link: "",
      alt_name: "CrewAI Multi-Agent",
      color_code: "#fffbf3",
    },
    {
      title: "Model Context Protocol: Advanced Topics",
      subtitle: "Anthropic | 2025",
      logo_path: "anthropic.png",
      certificate_link: "",
      alt_name: "MCP Anthropic",
      color_code: "#D4A574",
    },
    {
      title: "Introduction to Model Context Protocol",
      subtitle: "Anthropic | 2025",
      logo_path: "anthropic.png",
      certificate_link: "",
      alt_name: "MCP Intro",
      color_code: "#D4A574",
    },
    {
      title: "AI Agents in LangGraph",
      subtitle: "DeepLearning.AI | 2025",
      logo_path: "deeplearningai.png",
      certificate_link: "",
      alt_name: "LangGraph",
      color_code: "#fffbf3",
    },
    {
      title: "Multi AI Agent Systems with crewAI",
      subtitle: "DeepLearning.AI | 2025",
      logo_path: "deeplearningai.png",
      certificate_link: "",
      alt_name: "CrewAI",
      color_code: "#fffbf3",
    },
    {
      title: "Agentic AI",
      subtitle: "DeepLearning.AI | 2025",
      logo_path: "deeplearningai.png",
      certificate_link: "",
      alt_name: "Agentic AI",
      color_code: "#fffbf3",
    },
    {
      title: "Using Python to Access Web Data",
      subtitle: "University of Michigan | 2025",
      logo_path: "michigan.png",
      certificate_link: "",
      alt_name: "Python Web Data",
      color_code: "#00274C",
    },
    {
      title: "Python Data Structures",
      subtitle: "University of Michigan | 2025",
      logo_path: "michigan.png",
      certificate_link: "",
      alt_name: "Python Data Structures",
      color_code: "#00274C",
    },
    {
      title: "Master Go Programming",
      subtitle: "Udemy | 2025",
      logo_path: "udemylogo2.png",
      certificate_link: "",
      alt_name: "Go Programming",
      color_code: "#A435F0",
    },
    {
      title: "Certificate of Achievement",
      subtitle: "United Data Technologies | 2025",
      logo_path: "UDTLOGO.png",
      certificate_link: "",
      alt_name: "UDT Certificate of Achievement",
      color_code: "#E8EEF2",
    },
    {
      title: "Generative AI for Everyone",
      subtitle: "DeepLearning.AI | 2024",
      logo_path: "deeplearningai.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/verify/NHHHAGVE8XCW",
      alt_name: "DeepLearning",
      color_code: "#fffbf3",
    },
    {
      title: "Azure DevOps Fundamentals",
      subtitle: "Udemy | 2024",
      logo_path: "udemylogo2.png",
      certificate_link: "https://www.udemy.com/certificate/UC-6816bc59-9727-4c28-9f30-3eed27464bac/?utm_campaign=email&utm_medium=email&utm_source=sendgrid.com",
      alt_name: "AzureDevOps",
      color_code: "#A435F0",
    },
    {
      title: "Programming for Everybody (Getting Started with Python)",
      subtitle: "edX | 2024",
      logo_path: "edx-bootcamps-logo.jpg",
      certificate_link: "",
      alt_name: "Programming for Everybody",
      color_code: "#EDEDED",
    },
    {
      title: "Business Management with ERP Software",
      subtitle: "Instituto Percorre | 2015",
      logo_path: "cert-badge.svg",
      certificate_link: "",
      alt_name: "ERP Business Management",
      color_code: "#F1EDE6",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Software Engineer at UDT, Founder at Minas Digital, Programming Instructor",
  description:
    "Software Engineer with ten years in technology, specializing in event-driven cloud backends and workflow automation. Currently building a multi-tenant SaaS platform serving 40+ enterprise clients at United Data Technologies, running my own AI company at Minas Digital, and teaching programming to kids at Create & Learn.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Founder",
          company: "Minas Digital LLC",
          company_url: "https://yourlocalai.net/",
          logo_path: "YourLocalAI.png",
          duration: "Mar 2026 - Present",
          location: "Florida, US",
          description: `Founded an AI company building document intelligence for professional firms — legal, accounting, and healthcare — where sending client documents to a third-party API is not an acceptable answer. Shipped YourLocalAI, a desktop RAG application that lets users chat with their own documents on a locally hosted LLM: zero API cost, and nothing leaves the machine. Own the product end to end, from architecture and roadmap through branding and go-to-market.`,
          color: "#0E7C86",
        },
        {
          title: "Software Engineer",
          company: "United Data Technologies",
          company_url: "https://udtonline.com/",
          logo_path: "UDTLOGO.png",
          duration: "Sep 2024 - Present",
          location: "Remote",
          description: `Develop and maintain a multi-tenant SaaS platform serving 40+ enterprise clients, handling order management, shipment tracking, and inventory operations. Build serverless Azure Functions using TypeScript with Event Hubs integration for real-time data processing. Design and implement RESTful APIs and webhooks for seamless integration between internal systems and third-party services. Manage SQL Server database operations including schema migrations, stored procedures, and performance optimization. Build automated SendGrid notification pipelines, and review a large share of the team's code.`,
          color: "#117888",
        },
        {
          title: "Programming Instructor",
          company: "Create & Learn",
          company_url: "https://www.create-learn.us/",
          logo_path: "createandlearn.png",
          duration: "Oct 2025 - Present",
          location: "Remote",
          description: `Teach Scratch and Python programming to children through interactive online classes. Provide personalized feedback and adapt teaching methods to accommodate different learning styles. Manage virtual classroom dynamics and maintain student engagement throughout sessions.`,
          color: "#4285F4",
        },
        {
          title: "IT Repair Technician",
          company: "United Data Technologies",
          company_url: "https://udtonline.com/",
          logo_path: "UDTLOGO.png",
          duration: "Nov 2022 - Sep 2024",
          location: "Orlando, FL",
          description: `Repaired 5,500+ devices (Dell, Lenovo, Chromebook, HP) for Orange, Volusia, and Richland County Public Schools. Diagnosed and resolved issues with Windows, BIOS/UEFI, network adapters, memory, motherboards, and storage. Managed warranty processes and tracked repairs using ConnectWise.`,
          color: "#117888",
        },
        {
          title: "Freelance Full Stack Web Developer",
          company: "Freelance",
          company_url: "https://github.com/DiegoAR98",
          logo_path: "DABLUE.png",
          duration: "Mar 2024 - Present",
          location: "Remote",
          description: `Deliver frontend projects for small businesses using React, JavaScript, and modern CSS frameworks. Develop user-friendly, responsive interfaces optimized for performance and accessibility.`,
          color: "#e3405f",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "GitHub Student Developer",
          company: "GitHub",
          company_url: "https://github.com/",
          logo_path: "github.png",
          duration: "Nov 2022 - Present",
          location: "Remote",
          description:
            "Contribute to Open Source Community and Open Source Project.",
          color: "#040f26",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
  "Most of my day job lives in private repositories, so what follows is the work I can actually show: local-first AI products, multi-agent systems, and full-stack applications. Here is the code, not just the badges.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    description:
      "Feel free to reach out to me using the contact details below. I'll do my best to respond as quickly as possible!",
  },
};

const projects = {
  data: [
    {
      name: "YourLocalAI",
      url: "https://github.com/DiegoAR98/YourLocalAI-Release",
      deployedSite: "https://yourlocalai.net/",
      image: "YourLocalAI.png",
      alt_name: "YourLocalAI",
      description:
        "Chat with your own documents on a locally hosted LLM — zero API cost, and nothing leaves the machine. Built for professional firms with SvelteKit, FastAPI, ChromaDB and Ollama, shipped as a native Windows app.",
      languages: [
        {
          name: "Svelte",
          iconifyClass: "logos:svelte-icon",
        },
        {
          name: "TypeScript",
          iconifyClass: "logos:typescript-icon",
        },
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "FastAPI",
          iconifyClass: "devicon:fastapi",
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "logos-tailwindcss-icon",
        },
        {
          name: "ChromaDB",
          iconifyClass: "simple-icons:chroma",
        },
        {
          name: "Ollama",
          iconifyClass: "simple-icons:ollama",
        },
      ],
    },
    {
      name: "Triage AI",
      url: "https://github.com/DiegoAR98/Triage_AI",
      deployedSite: "https://triage-ai-h3gp.onrender.com/",
      image: "TriageAI.png",
      alt_name: "TriageAI",
      description:
        "A multi-agent system that runs patient anamnesis over chat, classifies urgency by the Manchester Triage Protocol, and routes to the right department. Built with CrewAI, FastAPI and ChromaDB for the Tetrate AI Buildathon.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "FastAPI",
          iconifyClass: "devicon:fastapi",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ChromaDB",
          iconifyClass: "simple-icons:chroma",
        },
        {
          name: "CrewAI",
          iconifyClass: "mdi:robot-outline",
        },
      ],
    },
    {
      name: "Agentic Labs",
      url: "https://github.com/DiegoAR98/Agentic_Labs",
      alt_name: "Agentic Labs",
      description:
        "My open playground for agentic workflows — multi-agent pipelines, orchestration patterns, and the Python ideas worth trying before they earn a place in production.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "CrewAI",
          iconifyClass: "mdi:robot-outline",
        },
        {
          name: "LangGraph",
          iconifyClass: "mdi:graph-outline",
        },
      ],
    },
    {
      name: "MCP Labs",
      url: "https://github.com/DiegoAR98/MCP_Labs",
      alt_name: "MCP Labs",
      description:
        "Model Context Protocol from the ground up — building servers and tools by hand to understand what the protocol actually guarantees, and what breaks in practice.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "Model Context Protocol",
          iconifyClass: "mdi:connection",
        },
      ],
    },
    {
      name: "KJV 1611",
      url: "https://github.com/DiegoAR98/KJV_1611",
      alt_name: "KJV 1611",
      description:
        "A language model whose entire world is one book: the 1611 King James Bible. An experiment in what a model actually learns when its corpus is small, closed, and deeply self-referential.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "NLP",
          iconifyClass: "mdi:text-box-search-outline",
        },
      ],
    },
    {
      name: "ArtisanConnect",
      url: "https://github.com/DiegoAR98/ArtisanConnect.DA",
      deployedSite: "https://artisanconnect-8fe5.onrender.com/",
      image: "artisanconnect.jpg",
      alt_name: "ArtisanConnect",
      description:
        "E-commerce platform that allows users to either purchase products or sell their own, specifically designed to support local farmers.",
      languages: [
        {
          name: "Tailwind CSS",
          iconifyClass: "logos-tailwindcss-icon",
        },
        {
          name: "React",
          iconifyClass: "vscode-icons:file-type-reactjs",
        },
        {
          name: "Express",
          iconifyClass: "skill-icons:expressjs-dark",
        },
        {
          name: "NodeJS",
          iconifyClass: "vscode-icons:file-type-node",
        },
        {
          name: "Apollo GraphQL",
          iconifyClass: "logos-apollostack",
        },
        {
          name: "JWT",
          iconifyClass: "logos-jwt-icon",
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
      ],
    },
    {
      name: "Google Books Search",
      url: "https://github.com/DiegoAR98/Book-Search-Engine",
      deployedSite: "https://book-search-engine-v9bj.onrender.com/",
      image: "book-search.png",
      alt_name: "Deployed site for Google Books Search",
      description:
        "MERN Stack search engine that allows users to create an account, search for books, and save books to a database.",
      languages: [
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb-icon",
        },
        {
          name: "Express",
          iconifyClass: "skill-icons:expressjs-dark",
        },
        {
          name: "NodeJS",
          iconifyClass: "vscode-icons:file-type-node",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "GraphQL",
          iconifyClass: "logos-graphql",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  errorPageInfo,
  socialMediaLinks,
  skills,
  majorEducation,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
